import { combineReducers } from 'redux';
import metaReducer from './meta';
import authReducer from './auth';
import localisationReducer from './localisation';
import customerDetailsReducer from './customerDetails';
import transactionsReducer from './transactions';
import accountSearchReducer from './accountSearchResult';
import cancellationReasonReducers from './cancellationReasons';
import accountMetaReducer from './accountMeta';
import facilitiesReducer from './facilities';
import guarantorReducer from './guarantorDetails';
import featureFlagsReducer from './featureFlags';
import suspensionRulesReducer from './suspensionRules';
import suspensionReducer from './suspensions';
import ssoGroupsReducer from './ssoGroupManagement';

// Follows the pattern mentioned here - https://github.com/erikras/ducks-modular-redux

const getRootReducer = () =>
  combineReducers({
    meta: metaReducer,
    auth: authReducer,
    localisation: localisationReducer,
    customerDetails: customerDetailsReducer,
    transactions: transactionsReducer,
    accountSearchResult: accountSearchReducer,
    cancellationReasons: cancellationReasonReducers,
    accountMeta: accountMetaReducer,
    facilities: facilitiesReducer,
    guarantorDetails: guarantorReducer,
    featureFlags: featureFlagsReducer,
    suspensions: suspensionReducer,
    suspensionRules: suspensionRulesReducer,
    ssoGroups: ssoGroupsReducer,
  });

export default getRootReducer;
